import { fetcher } from '@commenda/utils';

const deleteTransferPricingBenchmark = async (id: string) => {
  const res = await fetcher(`transfer-pricing/benchmark/${id}`, {
    method: 'DELETE',
  });

  return res;
};

export { deleteTransferPricingBenchmark };
